import React from 'react'
import Tooltip from '../../../../../itrust_common/components/others/Tooltip'
import { warrantyCoverage } from './warrantyCoverage'
import './WarrantyModal.scss'

const CheckShield = ({ size = 18, color = '#16A34A' }) => (
  <svg width={size} height={size} viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 2L95 20V52C95 82 75 105 50 118C25 105 5 82 5 52V20L50 2Z" fill={color} />
    <path d="M27 59L43 75L75 40" stroke="#FFFFFF" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default function WarrantyShieldIcon({ warranty, covers }) {
  if (!warrantyCoverage(warranty)[covers]) return null

  const status = String(warranty.status || '').toLowerCase()
  const isActive = status === 'active'
  const color = isActive ? '#16A34A' : '#9CA3AF'

  const tooltipContent = (
    <div>
      <div>{warranty.name || 'Warranty'}</div>
      {warranty.applies_to && <div>Applies to {warranty.applies_to}</div>}
      {warranty.term_value != null && warranty.term_unit && (
        <div>{warranty.term_value} {warranty.term_unit}</div>
      )}
      {warranty.status && <div className="text-capitalize">{warranty.status}</div>}
    </div>
  )

  return (
    <Tooltip tooltipContent={tooltipContent} tooltipClasses="d-inline-block ml-2">
      <span className={`warranty-shield-icon pointer d-inline-flex ${!isActive ? 'is-inactive' : ''}`}>
        <CheckShield color={color} />
      </span>
    </Tooltip>
  )
}
